<template>
  <Card class="flex gap-2 p-2 mb-2">
    <div
      class="size-4 rounded-full m-1  shrink-0"
      :style="{ backgroundColor: color }"
    ></div>
    <div>
      <div class="font-semibold ">{{ colorName }}</div>
      <div class="text-sm text-secondary">{{ explanation }}</div>
    </div>
  </Card>
</template>

<script setup>
import Card from "./Card.vue";

defineProps({
  color: {
    type: String,
    required: true,
  },
  colorName: {
    type: String,
    required: true,
  },
  explanation: {
    type: String,
    required: true,
  },
});
</script>
